import * as yup from 'yup';

const validationScheme = yup.object({
  subject: yup.number().min(1, 'Selecione o motivo').required('Selecione o motivo'),
  client_name: yup.string().required('Informe seu Nome'),
  client_contact: yup.string().email('E-mail inválido').required('Informe seu E-mail'),
  client_phone: yup.string().required('Informe seu Telefone'),
  message: yup.string().max(1000, 'Limite de caracteres').required('Escreva sua mensagem'),
});
export default validationScheme;
